import React from 'react';
import { useEffect, useState } from 'react';

const MenuItem = ({ item, isActive, onClick }) => {
  const [svgContent, setSvgContent] = useState('');
  const handleClick = (e) => { 
    // Only prevent default and call onClick for internal links
    if (item.target !== '_blank') {
      e.preventDefault();
      onClick(); 
    }
  };
  
  useEffect(() => {
    if (item.icon) {
      fetch(window.thhaAdminSettings.assets_url + 'img/' + item.icon + '.svg')
        .then(response => response.text())
        .then(svgText => setSvgContent(svgText))
        .catch(error => console.error('Error loading SVG:', error));
    }
  }, [item.icon]);

  const content = (
    <>
      {item.icon && item.iconPosition === 'left' && (
        <span 
          className={`menu-item-icon ${item.icon}`}
          dangerouslySetInnerHTML={{ __html: svgContent }} 
        />
      )}
      {item.title}
      {item.icon && item.iconPosition === 'right' && (
        <span 
          className={`menu-item-icon ${item.icon}`}
          dangerouslySetInnerHTML={{ __html: svgContent }} 
        />
      )}
    </>
  );

  return (
    <li className={`menu-item ${item.className} ${isActive ? 'active' : 'inactive'}`}>
      {item.link ? (
        <a 
          href={item.link} 
          className={`menu-item-link ${isActive ? 'active' : 'inactive'}`} 
          target={item.target || '_self'} // Use item.target if provided, otherwise _self
          rel={item.rel || ''} // Use item.rel if provided
          onClick={handleClick}
        >
          {content}
        </a>
      ) : (
        <span className={`menu-item-link ${isActive ? 'active' : 'inactive'}`}>
          {content}
        </span>
      )}
    </li>
  );
};

export default MenuItem;